import { isApplePayValidationError, isCommonError } from '../guards';

const getErrorMessageDetails = (error: unknown): string => {
    if (isApplePayValidationError(error)) {
        return `${error.name} ${error.message}`;
    }

    if (isCommonError(error)) {
        return error.message;
    }

    if (typeof error === 'string') {
        return error;
    }

    if (error instanceof Error) {
        return error.message;
    }

    return 'Unknown error occurred!';
};

export default getErrorMessageDetails;
